import * as React from 'react';

import {appHistory} from '../../../history';

import {ContextDocumentsLimitFooter} from './context-documents-limit-footer';
import {EmbeddedChatStatusToggle} from './embedded-chat-status-toggle';
import {InboxCreditUsageFooter} from './inbox-credit-usage-footer';

type Props = {
    isEmbedded: boolean;
};

export function EngagementSidebarFooter(props: Props) {
    const pathname = appHistory.location.pathname;

    if (pathname.includes('/sms')) {
        return <InboxCreditUsageFooter type='inbox' />;
    } else if (pathname.includes('/chat')) {
        if (pathname.includes('/settings/chat')) {
            return <ContextDocumentsLimitFooter />;
        }

        if (props.isEmbedded) {
            return <EmbeddedChatStatusToggle />;
        }
    }

    return null;
}
